var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40.613,
    viewBox: "0 0 40.611 40.613",
    width: 40.611,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m554.68 35.919 20.306 20.307 20.3-20.307-20.301-20.306zm34.3 0-14 14-14-14 14-14z",
    fill: "#fcda70",
    opacity: 1,
    transform: "translate(-554.68 -15.613)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape6);
export default __webpack_public_path__ + "static/media/shape-6.f5ce970707f19be6cc1580b6b58d3440.svg";
export { ForwardRef as ReactComponent };